import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthGate from './components/AuthGate';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import NewAudit from './pages/NewAudit';
import Dashboard from './pages/Dashboard';
import Report from './pages/Report';
import ClientShare from './pages/ClientShare';
import Portfolio from './pages/Portfolio';
import ClientPortfolio from './pages/ClientPortfolio';
import { ThemeProvider } from './utils/theme';
import GuestJourneyShare from './pages/GuestJourneyShare';

// Protected routes (require login)
function ProtectedApp() {
  return (
    <AuthGate>
      <div className="min-h-screen bg-black">
        <Navbar />
        <main className="pt-20 pb-12 px-4 sm:px-6 max-w-7xl mx-auto">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/new" element={<NewAudit />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/:auditId" element={<Dashboard />} />
            <Route path="/report/:auditId" element={<Report />} />
            <Route path="/portfolio" element={<Portfolio />} />
          </Routes>
        </main>
      </div>
    </AuthGate>
  );
}

export default function App() {
  return (
    <ThemeProvider>
    <BrowserRouter>
      <Routes>
        {/* Public routes — no login required */}
        <Route path="/portfolio/:companyId" element={
          <div className="min-h-screen bg-black">
            <ClientPortfolio />
          </div>
        } />
        <Route path="/client/:auditId" element={
          <div className="min-h-screen bg-black">
            <ClientShare />
          </div>
        } />
        <Route path="/journey/:auditId" element={
          <GuestJourneyShare />
        } />
        {/* Everything else requires auth */}
        <Route path="/*" element={<ProtectedApp />} />
      </Routes>
    </BrowserRouter>
    </ThemeProvider>
  );
}
